import React from 'react';
import { Mail, Phone, MapPin, Clock } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-gray-300">
      {/* Main footer content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="flex flex-col md:flex-row md:justify-between gap-8">
          {/* About Section */}
          <div className="md:max-w-md">
            <div className="flex items-center mb-4">
              <div
                className="h-16 w-16 rounded-full mr-3 bg-white p-1 bg-cover bg-center"
                style={{
                  backgroundImage: 'url(https://cdn.s3waas.gov.in/s368264bdb65b97eeae6788aa3348e553c/uploads/2018/04/2018040790.jpg)'
                }}
              />
              <div>
                <h3 className="text-white text-lg font-semibold">Mon District</h3>
              </div>
            </div>
            <p className="text-sm leading-relaxed mb-4">
              Land Record Digitization and Management Information System for Mon District, Nagaland.
            </p>
            <div className="space-y-2 text-sm">
              <div className="flex items-start">
                <MapPin className="h-4 w-4 mr-2 mt-1 flex-shrink-0" />
                <span>
                  <span className="text-gray-400">Address: </span>
                  Office of the Deputy Commissioner, Mon, Nagaland-798621
                </span>
              </div>
              <div className="flex items-start">
                <Clock className="h-4 w-4 mr-2 mt-1 flex-shrink-0" />
                <span>
                  <span className="text-gray-400">Office Hours: </span>
                  Mon-Sat 10:00 am to 04:00 pm
                </span>
              </div>
            </div>
          </div>

          {/* Contact */}
          <div className="md:text-right">
            <h3 className="text-white text-lg font-semibold mb-4">Contact Us</h3>
            <div className="space-y-3">
              <div className="flex items-center text-sm md:justify-end">
                <Phone className="h-4 w-4 mr-2 flex-shrink-0" />
                <span>
                  <span className="text-gray-400">Phone Number: </span>
                  <a href="tel:+918787377707" className="hover:text-white transition-colors">
                    8787377707 (PS to DC)
                  </a>
                </span>
              </div>
              <div className="flex items-center text-sm md:justify-end">
                <Mail className="h-4 w-4 mr-2 flex-shrink-0" />
                <span>
                  <span className="text-gray-400">Official Email: </span>
                  <a href="mailto:dcmon-ngl@gov.in" className="hover:text-white transition-colors">
                    dcmon-ngl@gov.in
                  </a>
                </span>
              </div>
              <div className="flex items-center text-sm md:justify-end">
                <Mail className="h-4 w-4 mr-2 flex-shrink-0" />
                <span>
                  <span className="text-gray-400">Official Gmail: </span>
                  <a href="mailto:dcmon17@gmail.com" className="hover:text-white transition-colors">
                    dcmon17@gmail.com
                  </a>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-gray-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="text-center">
            <p className="text-sm mb-2">&copy; {currentYear} Mon District Administration, Government of Nagaland. All rights reserved.</p>
            <p className="text-xs text-gray-500">
              Designed and Developed by District Administration, Mon, Nagaland
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
